import { camelToSnakeCase } from './string-utilis';

type QueryParams = Record<string, string | number | boolean | Record<string, 'asc' | 'desc'>>;

export const constructQueryParams = (baseUrl: string, queryParams: QueryParams): string => {
    const queryString = Object.entries(queryParams)
        .map(([key, value]) => {
            if (key === 'sort') {
                return formatSortQueryParams(value as Record<string, 'asc' | 'desc'>);
            } else {
                return formatFiltersQueryParam(key, value as string | number | boolean);
            }
        })
        .filter((param) => param)
        .join('&');

    return `${baseUrl}?${queryString}`;
};

export const formatSortQueryParams = (sortParams: Record<string, 'asc' | 'desc'>): string => {
    return Object.entries(sortParams)
        .map(([sortKey, sortOrder]) => {
            const formattedSort = `${camelToSnakeCase(sortKey)},${sortOrder.toUpperCase()}`;
            return `sort=${formattedSort}`;
        })
        .join('&');
};

export const formatFiltersQueryParam = (key: string, value: string | number | boolean): string => {
    return `${encodeURIComponent(camelToSnakeCase(key))}=${encodeURIComponent(String(value))}`;
};
